export { default as ScrollDown } from "./ScrollDown";


// WEBPACK FOOTER //
// ./src/components/ScrollDown/index.js